module.exports = __webpack_public_path__ + "assets/images/3DJz_BrBWs.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/Bdd/pages/gznyzyxy/print/image/app2.png
// module id = 2194
// module chunks = 0